import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { MMDirectAuth0Service } from '../../../services/authentication/mmdirect-auth0.service';

@Component({
    moduleId: module.id,
    selector: 'lifebridge-eligibility',
    templateUrl: './eligibility.component.html'
})
export class LifeBridgeEligibilityComponent implements OnInit {
    acknowledged: boolean;

    constructor(
        private amorphicService: AmorphicService,
        private route: ActivatedRoute,
        private authService: MMDirectAuth0Service,
        private router: Router) {
    }

    ngOnInit(): void {
        this.acknowledged = false;
    }

    async applyNow(): Promise<void> {
        //this.controller.initializeLifeBridge();
        const isAuth0Enabled: boolean = await this.authService.getIsAuth0Enabled();
        if (isAuth0Enabled) {
            this.authService.setLifeBridge();
            this.authService.goToAuthenticate();
        } else {
            this.router.navigate(['/login'], {fragment: 'RegisterLifeBridge'});
        }
    }

    toggleAcknowledged(): void {
        this.acknowledged = !this.acknowledged;
    }
}